module.exports = __webpack_public_path__ + "0ea3204c401f09ebf3f41e33a5751a2a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/menu/new.svg
// module id = 167
// module chunks = 0